import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { CloudFileQcDoneRequest } from "../../../../../common/api/master-api/cloud-files/qc-done/CloudFileQcDoneRequest";
import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileQueryKey } from "../../../details/common/CloudFileQueryKey";

export interface UseApproveCloudFileNotifications {
    cloudFileQcDone: SprintMutationResult<CloudFileQcDoneRequest, void>;
}

export const useCloudFileQcDone = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseApproveCloudFileNotifications => {
    const cloudFileApi = useCloudFileApi();
    const sprintQueryClient = useSprintQueryClient();

    const cloudFileQcDone = useSprintMutation<CloudFileQcDoneRequest>({
        mutationFn: async ({ cloudFileId }: CloudFileQcDoneRequest) => {
            if (!cloudFileId) {
                throw new Error("Cloud File ID is required to change status to QC Done.");
            }

            return cloudFileApi.cloudFileQcDone({ cloudFileId });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudFileQueryKey.CloudFileDetails, invalidationKey]
            });
        }
    });

    return {
        cloudFileQcDone
    };
};
